import { ROISoldData } from '@propertypal/shared/src/types/soldPriceData';
import getFormattedPrice from '@propertypal/shared/src/utils/property/getFormattedPrice';
import dayjs from 'dayjs';
import React, { FunctionComponent, useEffect, useState } from 'react';
import Loader from 'react-spinners/PulseLoader';
import { useTheme } from 'styled-components';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Cell, Column, Container, Labels, LoadingBox } from './SoldPriceTable.style';

interface Props {
  loading: boolean;
  soldData: ROISoldData[];
}

const BREAK_POINTS = {
  720: {
    slidesPerView: 3,
  },
  540: {
    slidesPerView: 2,
  },
  0: {
    slidesPerView: 1,
  },
};

const BREAK_POINTS_W_DISTANCE = {
  920: {
    slidesPerView: 4,
  },
  720: {
    slidesPerView: 3,
  },
  540: {
    slidesPerView: 2,
  },
  0: {
    slidesPerView: 1,
  },
};

const SoldPriceTable: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (props.loading || !mounted) {
    return (
      <LoadingBox data-testid="loading-sold-price-table">
        <Loader color={theme.backgroundLight} />
      </LoadingBox>
    );
  }

  const showDistance = !!props.soldData[0]?.distanceText;

  return (
    <Container>
      <Labels>
        <Cell>
          <p>ADDRESS</p>
        </Cell>

        {props.soldData.map((data) => (
          <Cell key={data.address}>
            <p>{data.address}</p>
          </Cell>
        ))}
      </Labels>

      <Swiper breakpoints={showDistance ? BREAK_POINTS_W_DISTANCE : BREAK_POINTS} simulateTouch style={{ flex: 1 }}>
        <SwiperSlide>
          <Column>
            <Cell>
              <p>SOLD DATE</p>
            </Cell>

            {props.soldData.map((data) => (
              <Cell key={data.address}>
                <p>{dayjs(data.soldDate).format('DD MMMM YYYY')}</p>
              </Cell>
            ))}
          </Column>
        </SwiperSlide>

        <SwiperSlide>
          <Column>
            <Cell>
              <p>SOLD PRICE</p>
            </Cell>

            {props.soldData.map((data) => (
              <Cell key={data.address}>
                <p>
                  <b>{getFormattedPrice(data.price.price, data.price.currencySymbol)}</b>
                </p>
              </Cell>
            ))}
          </Column>
        </SwiperSlide>

        <SwiperSlide>
          <Column>
            <Cell>
              <p>DESCRIPTION</p>
            </Cell>

            {props.soldData.map((data) => (
              <Cell key={data.address}>
                <p>{data.description}</p>
              </Cell>
            ))}
          </Column>
        </SwiperSlide>

        {showDistance && (
          <SwiperSlide>
            <Column>
              <Cell>
                <p>DISTANCE FROM PROPERTY</p>
              </Cell>

              {props.soldData.map((data) => (
                <Cell key={data.address}>
                  <p>{data.distanceText}</p>
                </Cell>
              ))}
            </Column>
          </SwiperSlide>
        )}
      </Swiper>
    </Container>
  );
};

export default SoldPriceTable;
